import {EActionStatus} from '@app/shared/enums/action-status.enum';
import {EState} from '@app/state/reducers';
import {createFeatureSelector, createSelector} from '@ngrx/store';
import {IAccountsState, IEditAccountDetails} from '../models/accounts.model';
import {ICustomersState} from '../models/customer-state.model';

export const selectCustomers = createFeatureSelector<ICustomersState>(EState.Customers);

export const selectAccountsState = createFeatureSelector<IAccountsState>(EState.Accounts);

export const selectAddAccountStatus = createSelector(
  selectAccountsState,
  (accountsState: IAccountsState) => accountsState.addAccountStatus
);

export const selectUpdateAccountStatus = createSelector(
  selectAccountsState,
  (accountsState: IAccountsState) => accountsState.updateAccountStatus
);

export const selectEditCustomerAccountDetails = createSelector(
  selectAccountsState,
  (accountsState: IAccountsState) => accountsState.editCustomerAccountDetails ?? ({} as IEditAccountDetails)
);

export const selectUpdateOrganizationStatus = createSelector(
  selectAccountsState,
  (accountsState: IAccountsState) => accountsState.updateOrganizationStatus === EActionStatus.Success
);

export const selectRoles = createSelector(selectAccountsState, (accountsState: IAccountsState) => accountsState.roles);
